import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReviewDetail } from '@/features/hr-performance/review-detail'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one review's scorecard (plans/16 Task 17).
 *
 * The grant guard lives in `beforeLoad`, as `apps/company/AGENTS.md` requires.
 * The API enforces the grant on the review endpoint regardless; the review is
 * only ever narrowed to its three parties.
 */
export const Route = createFileRoute('/_authenticated/hr/performance/reviews/$reviewId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'performance.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: ReviewDetailRoute,
})

function ReviewDetailRoute() {
  const { reviewId } = Route.useParams()
  return <ReviewDetail reviewId={reviewId} />
}
